import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonToggleDirective } from './button-toggle.directive';
import { ButtonToggleLabelDirective } from './button-toggle-label.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ButtonToggleDirective, ButtonToggleLabelDirective],
  exports: [ButtonToggleDirective, ButtonToggleLabelDirective],
})
export class ButtonToggleModule {}
